import { CompanyLogo } from '~/common/entities/CompanySettings/CompanySettingsTypes';
import { useCompanySettingsService } from '~/common/services/CompanySettingsService';
import { PictureType } from '~/common/entities/Pictures/PictureTypes';
import { Image, BoxProps, GridItem, Flex } from '@chakra-ui/react';
import { Base64Strings } from '~/common/utils/pictureUtils';
import React, { useEffect, useState } from 'react';
import { PictureUploadButton } from '..';

type LogoViewerProps = BoxProps;

export const LogoViewer: React.FC<LogoViewerProps> = ({ maxWidth = 280 }) => {
  const companySettings = useCompanySettingsService();
  const [companyLogo, setCompanyLogo] = useState<CompanyLogo>();

  useEffect(() => {
    void companySettings.fetchCompanyLogo(setCompanyLogo);
  }, []);

  const setCompanyLogoOnFileChange = async (
    base64StringsArray: Base64Strings,
  ) => {
    const newCompanyLogo: CompanyLogo = {
      picture: (base64StringsArray.base64 as unknown as string).replace(
        'data:image/jpeg;base64,',
        '',
      ),
      rotation: 0,
    };
    await companySettings.setCompanyLogo(newCompanyLogo);
    setCompanyLogo(newCompanyLogo);
  };

  return (
    <>
      <GridItem mb={2} colSpan={2}>
        <Flex alignItems="center">
          {companyLogo && companyLogo.picture ? (
            <Image src={companyLogo.picture} maxWidth={maxWidth} mr={2} />
          ) : null}
          <PictureUploadButton
            pictureType={PictureType.LOGO}
            projectOrJobId="0"
            multipleFiles={false}
            customHandleFileChange={setCompanyLogoOnFileChange}
            mt={3}
            ml={1}
          />
        </Flex>
      </GridItem>
      <GridItem colSpan={2} mb={2} />
    </>
  );
};
